import { useSearchParams } from "react-router-dom";
import {
    parseISO,
    startOfWeek,
    endOfWeek,
    format,
    subWeeks,
    addWeeks,
    isWithinInterval,
} from "date-fns";
import { useAppSelector } from "../../../hooks/useRedux";
import { useFetchWeeklySchedule } from "../../schedule/hooks/schedule.queries";

export default function useGetWeekViewData() {
    const { practice } = useAppSelector((state) => state.userPractice);
    const [searchParams] = useSearchParams();

    const currentWeekStart = startOfWeek(new Date(), { weekStartsOn: 1 });
    const currentWeekEnd = endOfWeek(new Date(), { weekStartsOn: 1 });

    const startOfWeekFallback = format(currentWeekStart, "yyyy-MM-dd");
    const endOfWeekFallback = format(currentWeekEnd, "yyyy-MM-dd");

    const startOfWeekOthers =
        searchParams.get("from_date") || startOfWeekFallback;
    const endOfWeekOthers = searchParams.get("to_date") || endOfWeekFallback;

    const clientIdsFilter = searchParams.getAll("client_ids[]") || [];

    const isWithinWeekRange = () => {
        const selectedWeekStart = parseISO(startOfWeekOthers);
        const currWeekStart = startOfWeek(new Date(), { weekStartsOn: 1 });

        const lastWeekStart = subWeeks(currWeekStart, 1);
        const nextTwoWeeksEnd = endOfWeek(addWeeks(currWeekStart, 2), {
            weekStartsOn: 1,
        });

        return isWithinInterval(selectedWeekStart, {
            start: lastWeekStart,
            end: nextTwoWeeksEnd,
        });
    };

    const otherWeeks = useFetchWeeklySchedule({
        client_ids: clientIdsFilter,
        provider_ids: [practice?.provider_id || ""],
        from_date: startOfWeekOthers,
        to_date: endOfWeekOthers,
        schedule_for_form: isWithinWeekRange(),
    });

    return {
        loading: otherWeeks.isLoading,
        data: otherWeeks.data,
        error: otherWeeks.error,
        isSuccess: otherWeeks.isSuccess,
        isWithinInterval: isWithinWeekRange(),
    };
}
